import * as React from 'react';
import { PiralDocsInfoBarComponentProps } from '../scripts/types';

const InfoBar: React.FC<PiralDocsInfoBarComponentProps> = () => null;

export default InfoBar;
